
<nav class="navbar navbar-default" style="margin-bottom:0px">
  <div class="container-fluid">
      <div class="container-fluid" id="content-container">
        <ul class="nav navbar-nav">
          <li routerLinkActive="active" class="nav-item">
            <a routerLink="/main" id="title">
              <h1>
                Meistercards
              </h1>
            </a>
          </li>
        </ul>
        <div class="extra-links">
          <div>
            <a target="_blank" href="https://www.youtube.com/@MeisterCards">
              <img src="assets/yt_icon_mono_dark.png" width="24" height="23"/>
            </a>
          </div>
          <div>
            <a target="_blank" href="https://www.twitch.tv/timegamemeisters">
              <img src="assets/glitch_flat_white.png" width="24" height="24"/>
            </a>
          </div>
          <div>
            <a target="_blank" href="https://discord.gg/qPmJx3y5vj">
              <img src="assets/Discord-Symbol-White.png" width="24" height="24"/>
            </a>
          </div>
          <div>
            <a target="_blank" href="https://www.instagram.com/meistercards/">
              <img src="assets/Instagram_Glyph_White.png" width="24" height="24"/>
            </a>
          </div>
        </div>
    </div>
  </div>
</nav>